const STORE_KEY = 'WRITING'

export const FETCH_WRITING = `${STORE_KEY}/FETCH_WRITING`
